/** SPECS: __tests__/crew-route-day-selection.test.ts
 *
 * Central-time date primitives shared by server and browser code.
 *
 * Route-day, crew-time, payroll, and billing dates are bare YYYY-MM-DD values
 * in America/Chicago. Keep the timezone explicit so a host or browser's local
 * timezone cannot move an operation across a Central-time date boundary.
 */

export const CENTRAL_TIME_ZONE = 'America/Chicago';

/** Convert a Date to YYYY-MM-DD in US Central time. */
export function toLocalDateStr(date: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: CENTRAL_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

/** Get today's YYYY-MM-DD date in US Central time. */
export function getLocalToday(): string {
  return toLocalDateStr(new Date());
}
